package com.clany.backoffice.model

import kotlinx.serialization.Serializable

@Serializable
data class SubscriptionResponse(
    val id: String,
    val accountId: String,
    val accountName: String,
    val plan: String,
    val status: String,
    val expiresAt: String
)

@Serializable
data class UpdateSubscriptionPlanRequest(
    val plan: String,
    val status: String
)
